<div class="p-2 page-height overflow-auto bg-panel">
  <mat-card class="rounded-md page-container">
    <mat-card-content>
      <div>
        @if (page === 'payment') {
          <div
            class="page-header mb-4"
            data-test="app-virtual-terminal-header"
          >
            <h4 class="mb-1">Virtual Terminal</h4>
            <p class="text-muted mb-0">
              Take a card payment on behalf of your customer.
            </p>
          </div>
        }

        @switch (page) {
          @case ('payment') {
            <ng-container *ngTemplateOutlet="paymentForm"></ng-container>
          }
          @case ('success') {
            <ng-container *ngTemplateOutlet="paymentSuccess"></ng-container>
          }
          @case ('failed') {
            <ng-container *ngTemplateOutlet="paymentFail"></ng-container>
          }
        }
      </div>

      <odin-loading-spinner
        class="card-spinner"
        [active]="processing"
        [overlay]="true"
      ></odin-loading-spinner>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #paymentForm>
  <odin-dynamic-form
    [disabledInput]="!PermissionChecker() || processing"
    [formData]="virtualTerminalForm"
  ></odin-dynamic-form>
</ng-template>

<ng-template #paymentSuccess>
  <div class="text-center">
    <div class="position-relative p-3 w-fit m-auto">
      <div
        class="d-flex align-items-center justify-content-center rounded-circle m-auto large-icon text-center"
      >
        <mat-icon style="color: green" class="d-block w-fit h-fit display-1"
          >verified</mat-icon
        >
      </div>
    </div>
    <p class="fw-bold">Your payment was successful!</p>
    @if (paymentResponse) {
      <p>Authorisation Code: {{ paymentResponse.message }}</p>
    }
    <p>Click the button below to print a receipt for this transaction.</p>
    <div class="mt-1 d-flex justify-content-center align-items-center gap-3">
      <button
        mat-mini-fab
        class="mon-bg-primary mon-border-primary border mon-text-primary"
        (click)="PrintReceipt()"
        data-test="app-virtual-terminal-print-receipt-button"
      >
        <mat-icon>print</mat-icon>
      </button>
    </div>

    <div class="mt-3">
      <button
        mat-raised-button
        color="accent"
        (click)="ResetPage(true)"
        data-test="app-virtual-terminal-reset-page-button"
      >
        Make New Payment
      </button>
    </div>
  </div>

  <!-- Receipt print template -->
  @if (lastRequest) {
    <div #printTemplate>
      <odin-print-receipt [receiptDetail]="receiptDetail"></odin-print-receipt>
    </div>
  }
</ng-template>

<ng-template #paymentFail>
  <div class="text-center">
    <div class="position-relative p-3 w-fit m-auto">
      <div
        class="d-flex align-items-center justify-content-center rounded-circle m-auto large-icon text-center"
      >
        <mat-icon class="d-block w-fit h-fit display-1" style="color: red"
          >cancel</mat-icon
        >
      </div>
    </div>
    <p class="fw-bold">Your payment was unsuccessful!</p>
    @if (paymentResponse) {
      <p>Reason: {{ paymentResponse.message }}</p>
      <p>Transaction Request ID: {{ paymentResponse.traceId }}</p>
    }
    <div
      class="mt-3 mx-auto d-block justify-content-between align-items-center gap-2 d-md-flex"
      style="max-width: 600px"
    >
      <button
        [disabled]="processing || retryCount >= 3"
        mat-raised-button
        color="accent"
        (click)="RetryPayment()"
        class="w-100 my-1 mx-auto"
        data-test="app-virtual-terminal-retry-payment-button"
      >
        {{ retryCount < 3 ? 'Retry Payment' : 'Too many retries' }}
      </button>
      @if (retryCount < 3) {
        <button
          [disabled]="processing || retryCount >= 3"
          mat-raised-button
          color="accent"
          (click)="ResetPage(false)"
          class="w-100 my-1 mx-auto"
          data-test="app-virtual-terminal-update-details-button"
        >
          {{ retryCount < 3 ? 'Update Payment Details' : 'Too many retries' }}
        </button>
      }
      <button
        [disabled]="processing"
        mat-flat-button
        color="primary"
        (click)="ResetPage(true)"
        class="w-100 my-1 mx-auto"
        data-test="app-virtual-terminal-reset-page-button"
      >
        Make New Payment
      </button>
    </div>
  </div>
</ng-template>
